import { Component, ViewChild, Input } from '@angular/core';
import { animateList } from 'src/shared/animations';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { AuditTrail } from 'src/shared/api';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'rpfsa-audit-trail-list',
	templateUrl: './audit-trail-list.component.html',
	styleUrls: ['./audit-trail-list.component.css'],
	animations: [animateList],
})
export class AuditTrailListComponent extends SelfDestruct {
	@ViewChild(MatSort, { static: true }) set sort(sort: MatSort) {
		this.dataSource.sort = sort;
	}
	@ViewChild(MatPaginator, { static: true }) set paginator(
		paginator: MatPaginator
	) {
		this.dataSource.paginator = paginator;
	}
	@Input() set auditTrails(auditTrails: AuditTrail[]) {
		this.dataSource.data = auditTrails;
	}
	@Input() isLoading: boolean;
	@Input() listMessage: string;
	@Input() paginatorLayoutAlign = 'end center';

	readonly resultColumns = ['createdBy', 'description', 'created'];
	readonly emptyColumns = ['empty'];

	readonly dataSource = new MatTableDataSource();
}
